export const HOUSEHOLD_PORTFOLIO_ERROR_CODES = new Set([
  'NOT_ACCESSIBLE',
  'PORTFOLIO_RESTRICTED',
  'NOT_CUSTOMIZED',
  'WRONG_REPORT_MEMBER',
  'PRODUCT_NOT_HELD',
  'CAPACITY_BREACH',
  'WEIGHT_SUM_OUT_OF_RANGE',
  'AMOUNT_SUM_OUT_OF_RANGE',
  'AGGREGATE_CONSERVATION',
  'BAD_USER_INPUT',
]);
